export var DEPRECATED_APPEARANCES_ENUM = [
    'primary',
    'secondary',
    'tertiary'
];
export var APPEARANCES_ENUM = [
    'filled',
    'lined',
    'ghost'
];
export var DEPRECATED_VARIANTS_ENUM = [
    'accent',
    'interactive',
    'neutral',
    'success',
    'tertiary',
    'warning'
];
export var TRANSPARENT_COLOR = 'rgba(0,0,0,0)';
export var VARIANTS_ENUM = [
    'brand',
    'neutral-white',
    'neutral-black',
    'menu',
    'danger'
];
